<template>
    <div class="extra-fields-filter">
        <nestable-tree id="extra"
                        :value="selectedExtraFieldsWithValue"
                       :options="extraFields"
                       :normalizer="normalizer"
                       :no-options-text="$t('message.automation.message.noExtraFields')"
                       :placeholder="$t('message.automation.message.extraFields')"
                       @input="displayOptions">
            <div slot="option-label"
                 slot-scope="{ node }">
                <filter-local-tree-item :node="node" :showIcons="false"/>
            </div>
        </nestable-tree>
        <template v-if="hasSelectedBooleanExtraFields"
                    v-for="booleanExtraField in selectedBooleanExtraFields">
            <div v-if="booleanExtraField.type === 'BOOLEAN'">
                <label>{{booleanExtraField.label}}</label>
                <v-radio-group v-model="booleanExtraField.value"
                               @change="setExtraFieldValue(booleanExtraField.id, $event)"
                               row>
                    <v-radio :value="true"  :label="$t('message.automation.message.yes')"></v-radio>
                    <v-radio :value="false" :label="$t('message.automation.message.no')"></v-radio>
                </v-radio-group>
            </div>
            <div v-if="booleanExtraField.type === 'OPTION'">
                <label>{{booleanExtraField.label}}</label>
                <v-select  class="padding"
                           v-model="booleanExtraField.value"
                           :items="booleanExtraField.options"
                           multiple
                           chips
                           :label="label(booleanExtraField.value)"
                           @input="setExtraFieldValue(booleanExtraField.id, $event)">
                    <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index === 0">
                            <span>{{ item }}</span>
                        </v-chip>
                        <span v-if="index === 1">
                            (+{{ booleanExtraField.value.length - 1 }} )
                        </span>
                    </template>
                </v-select>
            </div>
        </template>
    </div>
</template>

<script>
import FilterLocalTreeItem from "@/components/filters/local/tree/item/FilterLocalTreeItem";
import NestableTree from "@/components/generic/nestable/tree/NestableTree";

export default {
    components: {
        NestableTree,
        FilterLocalTreeItem,
    },

    data() {
        return {
            extraFieldsLoaded: false,
            extraFields: [],
            normalizer(node) {
                return {
                    id: node.id,
                    label: node.label,
                    name: node.name,
                    value: node.value
                };
            },
            selectedBooleanExtraFields: [],
            selectedExtraFieldsWithValue: [],
            selected: []
        };
    },

    props: {
        value: {
            type: String,
        },
        step: {
            type: Object,
        },
    },

    computed: {
        establishmentId() {
            return this.$store.state.users.user.accountId
        },
        hasSelectedBooleanExtraFields() {
            return this.selectedBooleanExtraFields.length > 0
        },

    },

    watch: {},

   async created() {
      await this.loadExtraFields();
      await this.setSelectedExtraFieldsAndOptions()
    },

    methods: {
        displayOptions(val) {
          if(val.length === 0) {
              this.selectedBooleanExtraFields = []
              this.$emit('change', val)
              return
          }
          if(val.length < this.selectedBooleanExtraFields.length) {
              const array = []
              val.map(item => {
                  const fieldToInclude = this.extraFields.find(field => field.id === item)
                  array.push(fieldToInclude)
              })
              this.selectedBooleanExtraFields = array
              this.$emit('change', array)
              return;
          }
          val.map(item => {
                this.selectedBooleanExtraFields.push(...this.extraFields.filter(extraField => {
                    if(extraField.id === item && !this.selectedBooleanExtraFields.includes(extraField))
                        return extraField
                }))
            })
            const newArray = this.selectedBooleanExtraFields.filter(item => val.includes(item.id))
            this.selectedBooleanExtraFields = [...newArray]
        },
        setNodes(node) {
            const newVal = [...this.value];

            const localIndex = newVal.findIndex((selectedNodeId) => {
                return selectedNodeId === node.localTreeId;
            });

            if (localIndex > -1) {
                newVal.splice(localIndex, 1);
            } else {
                newVal.push(node.localTreeId);
            }

            this.emitInput(newVal);
        },
        async loadExtraFields() {
            try {
                this.extraFieldsLoaded = false;

                const list = await this.$api.core.extraField.extraFieldsListAutomation();

                list.map((item) => {
                    if(item.type === 'BOOLEAN') {
                        item.value = undefined
                    } else {
                        item.value = undefined
                        item.indexesOfvalues = []
                    }

                } );

                this.extraFields = list;

                this.extraFieldsLoaded = true;
            } catch (error) {
                console.log(error);
            }
        },
        setExtraFieldValue(id, e, index) {
           const fieldsWithValues = this.selectedBooleanExtraFields.map(item => {
                if(item.id === id) {
                    if(item.type === 'BOOLEAN') {
                        item.value = e
                    } else {
                        if(!item.value)
                            item.value = []
                        if(e.length === 0) {
                            item.value = []
                            return item
                        }
                        if(e.length < item.value.length) {
                            e.map(idx => {
                                const array = []
                                const option = item.options.find(opt => opt === idx)
                                array.push(option)
                                item.value = array
                                return item
                            })
                        }
                        e.map(idx => {
                            const option = item.options.find(opt => opt === idx)
                            !item.value.includes(option) && item.value.push(option)
                            return item
                        })

                    }
                }
               return item
            })
            this.$emit('change', fieldsWithValues)
        },
        setSelectedExtraFields() {
            const selectedExtraFieldsObj = JSON.parse(this.value)
            for (const name in selectedExtraFieldsObj) {
                const foundField = this.extraFields.find(field => field.name === name)
                this.selectedExtraFieldsWithValue.push(foundField.id)
            }
        },
        setSelectedOptions() {

            const selectedExtraFieldsObj = JSON.parse(this.value)
            for (const name in selectedExtraFieldsObj) {
                const foundField = this.extraFields.find(field => field.name === name)
                foundField.value = selectedExtraFieldsObj[name]
                if(foundField.type === 'BOOLEAN') {
                    this.selectedBooleanExtraFields.push(foundField)
                } else {
                    const optionExtraField = this.extraFields.find(field => field.name === name)
                    const arrayOfOptionsIndexes = optionExtraField.value.map(item => {
                        if(optionExtraField.options.includes(item))
                            return optionExtraField.options.indexOf(item)
                    })
                    foundField.indexesOfvalues = [...arrayOfOptionsIndexes]
                }

            }
        },
        setSelectedExtraFieldsAndOptions() {
            this.setSelectedExtraFields();
            this.setSelectedOptions()
        },
        label(value) {
            if(!value || value.length === 0) {
                return "Selecione"
            } else {
                return ''
            }
        }

    },


    beforeDestroy() {},

    mixins: [],


};
</script>

<style lang="scss" scoped>

#extra {
    margin-bottom: 15px;

    ::v-deep .vue-treeselect__list-item {
        margin-bottom: 5px;
    }
    ::v-deep .vue-treeselect__label-container {
        display: flex;
        gap: 8px;       

    }
    ::v-deep .vue-treeselect__checkbox-container {
        padding-top: 4px;
    }
    
}

.container {
    padding: 0 ;
}

.v-select {
    padding: 0;
    margin-top: 16px !important;
}

.v-text-field {
    padding: 0 !important;
}

</style>
